import React from 'react';
import domPurify from 'utils/domPurify';
import { useTranslation } from 'i18n';
import { Grid, Typography, useMediaQuery } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import IconWithText from 'components/common/IconWithText';
import { getIconByAttribute } from 'components/common/editEventIcons';

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: '32px !important',
    borderRadius: 8,
    background: theme.palette.background.default,
  },
  description: {
    margin: '-1rem 0',
    wordBreak: 'break-word',
    lineHeight: '21px',
    fontWeight: 500,
  },
  title: {
    alignSelf: 'baseline',
    fontWeight: 600,
  },
}));

type AdditionalInstructionType = {
  id: number;
  slug: string;
  text_for_non_registered: string;
  text_for_registered: string;
  title: string;
};

interface IProps {
  additionalInstructions: AdditionalInstructionType[];
}

const AdditionalInstructions: React.FC<React.PropsWithChildren<IProps>> = ({ additionalInstructions }) => {
  const { classes } = useStyles();
  const [t] = useTranslation('public');
  const less664 = useMediaQuery('(max-width: 664px)');

  return (
    <Grid container spacing={3} gap={3} justifyContent="space-between">
      {additionalInstructions.map(({ text_for_non_registered, text_for_registered, title, slug }) => (
        <Grid
          item
          xs={additionalInstructions?.length > 1 && !less664 ? 6 : 12}
          style={{ maxWidth: additionalInstructions?.length > 1 && !less664 ? 302 : '100%' }}
          className={classes.container}
        >
          <Grid container spacing={3}>
            <Grid item>
              <Grid container spacing={1.25}>
                <Grid item>
                  <Grid container>
                    <IconWithText
                      color="initial"
                      variant="body2"
                      icon={getIconByAttribute(slug)}
                      text={title || t(`screen.event.additionalInstruction.${slug}`)}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    component="div"
                    color="textSecondary"
                    className={classes.description}
                    dangerouslySetInnerHTML={{
                      __html: domPurify.sanitize(text_for_registered || text_for_non_registered),
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default React.memo(AdditionalInstructions);
